module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid"
  }, _vm._l((_vm.cells), function(cell) {
    return _c('div', {
      key: cell,
      staticClass: "cell"
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2060a48f"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/gamecontainer/grid.vue
// module id = 37
// module chunks = 0